import * as React from "react"
import MCSEOFooter from "./MCSEOFooter"

const style ={
    backgroundColor: '#eadddd',
    borderTop: '1px solid #dedede'
}
function MCFooter(props) {

    return (
        <div>
            {MCSEOFooter()}
            
            <div style={style} 
                    className="h-32 flex flex-row place-content-center items-center text-base">
                    
                    <div className='flex-auto pl-10 flex place-content-center items-center'>
                        <img src={props.logo} style={{maxHeight:'50px'}}/>
                    </div>
                    <div className='flex-auto flex place-content-center items-center'>
                        <a href="/apps/magicrop/terms">Terms</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                        <a href="/apps/magicrop/privacy">Privacy</a>
                    </div>
                    <div className='flex-auto flex place-content-center items-center'>
                    2021 Magicrop. All rights reserved.
                    </div>
            </div>
        </div>)
}

export default MCFooter